(function () {
  const scriptEl = document.currentScript;
  const sectionId = scriptEl.dataset.acSectionId;
  const root = document.getElementById(`ac-shop-${sectionId}`);
  if (!root) return;

  const taxonomy = (window.ACShopTaxonomy && window.ACShopTaxonomy.primaries) || [];

  const items = Array.from(root.querySelectorAll('[data-ac-shop-item]'));
  const addButtons = root.querySelectorAll('[data-ac-add-to-bag]');
  const toast = document.getElementById(`ac-shop-toast-${sectionId}`);

  const primaryRail = root.querySelector('[data-ac-primary-rail]');
  const primaryPrev = root.querySelector('[data-ac-primary-rail-prev]');
  const primaryNext = root.querySelector('[data-ac-primary-rail-next]');

  const secondaryWrap = root.querySelector('[data-ac-secondary-rail-wrap]');
  const secondaryRail = root.querySelector('[data-ac-secondary-rail]');
  const secondaryPrev = root.querySelector('[data-ac-secondary-rail-prev]');
  const secondaryNext = root.querySelector('[data-ac-secondary-rail-next]');

  // Placeholder illustrations for photo-less products are filled in globally
  // by ac-shared.js (runs on every page that loads it), so nothing to do here.

  // Read each product's taxonomy tags off the DOM once. Product data never
  // changes after render, so this is the only pass needed.
  const productData = items.map((item) => ({
    el: item,
    primaries: (item.dataset.acPrimary || '').split(' ').filter(Boolean),
    children: (item.dataset.acChild || '').split(' ').filter(Boolean),
  }));

  function countFor(tag) {
    return productData.filter((p) => p.primaries.includes(tag) || p.children.includes(tag)).length;
  }

  // Only categories with at least one published, tagged product ever appear —
  // this is what lets "Pets" (or a new child like "Grandad") show up on its
  // own the moment real products exist, with zero code changes.
  const livePrimaries = taxonomy
    .map((primary) => ({ ...primary, count: countFor(primary.tag) }))
    .filter((primary) => primary.count > 0);

  // Minimum distinct, non-empty children a primary needs before its secondary
  // rail is worth showing at all — a single child duplicates "All <Primary>"
  // with no navigation value, so it's suppressed until there's real depth.
  const MIN_CHILDREN_TO_SHOW_RAIL = 2;

  const state = { primary: 'all', child: null };

  const allBtn = primaryRail && primaryRail.querySelector('[data-ac-primary="all"]');
  if (allBtn) {
    allBtn.addEventListener('click', () => {
      state.primary = 'all';
      state.child = null;
      render();
    });
  }

  function setupRail(rail, prevBtn, nextBtn) {
    if (!rail || !prevBtn || !nextBtn) return () => {};
    const update = () => {
      const overflowing = rail.scrollWidth > rail.clientWidth + 4;
      prevBtn.hidden = !overflowing || rail.scrollLeft <= 4;
      nextBtn.hidden = !overflowing || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    const scrollBy = (dir) => {
      rail.scrollBy({ left: dir * Math.round(rail.clientWidth * 0.6), behavior: 'smooth' });
    };
    prevBtn.addEventListener('click', () => scrollBy(-1));
    nextBtn.addEventListener('click', () => scrollBy(1));
    rail.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return update;
  }

  const updatePrimaryRailNav = setupRail(primaryRail, primaryPrev, primaryNext);
  const updateSecondaryRailNav = setupRail(secondaryRail, secondaryPrev, secondaryNext);

  function makePillButton({ label, pressed, extraClass }) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = extraClass ? `ac-cat-btn ${extraClass}` : 'ac-cat-btn';
    if (pressed) btn.classList.add('ac-cat-active');
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    btn.textContent = label;
    return btn;
  }

  function render() {
    // --- Primary rail ---
    const allBtn = primaryRail.querySelector('[data-ac-primary="all"]');
    allBtn.classList.toggle('ac-cat-active', state.primary === 'all');
    allBtn.setAttribute('aria-pressed', state.primary === 'all' ? 'true' : 'false');

    primaryRail.querySelectorAll('[data-ac-primary]:not([data-ac-primary="all"])').forEach((el) => el.remove());
    livePrimaries.forEach((primary) => {
      const btn = makePillButton({ label: primary.label, pressed: state.primary === primary.key });
      btn.dataset.acPrimary = primary.key;
      btn.addEventListener('click', () => {
        state.primary = state.primary === primary.key ? 'all' : primary.key;
        state.child = null;
        render();
      });
      primaryRail.appendChild(btn);
    });
    updatePrimaryRailNav();

    // --- Secondary rail ---
    secondaryRail.innerHTML = '';
    const activePrimary = livePrimaries.find((p) => p.key === state.primary);
    let liveChildren = [];

    if (activePrimary) {
      const productsInPrimary = productData.filter((p) => p.primaries.includes(activePrimary.tag));
      liveChildren = activePrimary.children
        .map((child) => ({
          ...child,
          count: productsInPrimary.filter((p) => p.children.includes(child.tag)).length,
        }))
        .filter((child) => child.count > 0);
    }

    const showSecondary = activePrimary && liveChildren.length >= MIN_CHILDREN_TO_SHOW_RAIL;
    secondaryWrap.hidden = !showSecondary;

    if (showSecondary) {
      const allChildBtn = makePillButton({
        label: `All ${activePrimary.label}`,
        pressed: state.child === null,
        extraClass: 'ac-subcat-btn',
      });
      allChildBtn.addEventListener('click', () => {
        state.child = null;
        render();
      });
      secondaryRail.appendChild(allChildBtn);

      liveChildren.forEach((child) => {
        const btn = makePillButton({
          label: child.label,
          pressed: state.child === child.key,
          extraClass: 'ac-subcat-btn',
        });
        btn.addEventListener('click', () => {
          state.child = state.child === child.key ? null : child.key;
          render();
        });
        secondaryRail.appendChild(btn);
      });
    } else if (!activePrimary) {
      state.child = null;
    }
    updateSecondaryRailNav();

    // --- Product grid ---
    const activeChildTag =
      activePrimary && state.child ? activePrimary.children.find((c) => c.key === state.child)?.tag : null;

    productData.forEach((p) => {
      let show = true;
      if (activePrimary) {
        show = p.primaries.includes(activePrimary.tag);
        if (show && activeChildTag) show = p.children.includes(activeChildTag);
      }
      p.el.hidden = !show;
    });
  }

  render();

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('ac-show');
    setTimeout(() => toast.classList.remove('ac-show'), 1300);
  }

  addButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      const title = btn.dataset.productTitle || 'Item';
      if (!variantId || btn.disabled || !window.ACShared) return;

      btn.setAttribute('aria-disabled', 'true');
      window.ACShared.addToCart(variantId, {
        onSuccess: () => {
          showToast(`${title.toUpperCase()} ADDED`);
          btn.removeAttribute('aria-disabled');
        },
        onError: (message) => {
          showToast(message || 'Could not add to bag');
          btn.removeAttribute('aria-disabled');
        },
      });
    });
  });
})();
